<div class="landing-container">
  <!-- Header -->
  <header class="landing-header">
    <div class="header-container">
      <div class="logo">
        <img src="/assets/icons/Loqt_Logotype-06.svg" alt="LOQT" class="logo-image">
      </div>
      <nav class="nav-actions">
        <a routerLink="/whats-new" class="whats-new-link">What's new</a>
        <button mat-button (click)="navigateToLogin()" class="login-btn">Login to Your School</button>
        <button mat-flat-button (click)="navigateToSignup()" class="signup-btn">Create School Account</button>
      </nav>
    </div>
  </header>

  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-content">
      <span class="hero-eyebrow">Screen-time management for schools</span>
      <a class="hero-announce" routerLink="/whats-new" *ngIf="latestReleaseTitle">
        <span class="hero-announce-badge">New</span>
        <span class="hero-announce-text">{{ latestReleaseTitle }} release. See what's new</span>
        <mat-icon>arrow_forward</mat-icon>
      </a>
      <h1 class="hero-title">
        Calm classrooms.<br>
        Focused students.<br>
        <span class="hero-title-accent">Better learning.</span>
      </h1>
      <p class="hero-subtitle">
        Smartphones are one of the biggest barriers to concentration and calm in schools.
      </p>
      <p class="hero-description">
        LOQT helps you manage phone use during the school day. It also connects with parents to build
        consistent habits at home.
      </p>
      <div class="hero-actions">
        <button mat-flat-button (click)="navigateToSignup()" class="cta-primary">
          Create School Account
        </button>
        <button mat-button (click)="navigateToLogin()" class="cta-secondary">
          Login to Your School
        </button>
      </div>
      <ul class="hero-highlights">
        <li><mat-icon>schedule</mat-icon>Timetable-aware schedules</li>
        <li><mat-icon>menu_book</mat-icon>Learning apps stay available</li>
        <li><mat-icon>swap_horiz</mat-icon>Parent handover after school</li>
        <li><mat-icon>event_busy</mat-icon>Holidays and closures respected</li>
      </ul>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features-section">
    <div class="section-head">
      <span class="section-eyebrow">Benefits</span>
      <h2 class="section-title">Why schools choose LOQT</h2>
      <p class="section-lead">One approach that works for everyone around the student.</p>
    </div>
    <div class="features-grid">
      <div class="feature-card accent-green">
        <span class="feature-icon-tile"><mat-icon>class</mat-icon></span>
        <h3>For Teachers</h3>
        <ul>
          <li>Calmer classrooms and fewer disruptions</li>
          <li>More teaching time, less phone policing</li>
          <li>Improved student focus and engagement</li>
        </ul>
      </div>
      <div class="feature-card accent-blue">
        <span class="feature-icon-tile"><mat-icon>business</mat-icon></span>
        <h3>For School Leaders</h3>
        <ul>
          <li>Reinforces digital wellbeing policies</li>
          <li>Demonstrates measurable impact</li>
          <li>Strengthens school and home collaboration</li>
        </ul>
      </div>
      <div class="feature-card accent-yellow">
        <span class="feature-icon-tile"><mat-icon>family_restroom</mat-icon></span>
        <h3>For Families</h3>
        <ul>
          <li>Shared approach reduces conflict</li>
          <li>Students learn self-regulation</li>
          <li>Builds trust between home and school</li>
        </ul>
      </div>
    </div>
  </section>

  <!-- How It Works Section -->
  <section class="how-it-works-section">
    <div class="section-head">
      <span class="section-eyebrow">Getting started</span>
      <h2 class="section-title">How it works</h2>
      <p class="section-lead">Three steps from setup to a phone-free school day.</p>
    </div>
    <div class="how-it-works-grid">
      <div class="work-card">
        <div class="work-number">1</div>
        <h3>Set schedules</h3>
        <p>Integrate with your timetable systems and set phone-free times by class, year or location.</p>
      </div>
      <div class="work-card">
        <div class="work-number">2</div>
        <h3>Automatic control</h3>
        <p>Social and gaming apps pause during lessons. Educational apps stay active.</p>
      </div>
      <div class="work-card">
        <div class="work-number">3</div>
        <h3>Parent connection</h3>
        <p>Control reverts to parents after school for consistent routines at home.</p>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta-section">
    <div class="cta-content">
      <h2>Ready to create a better learning environment?</h2>
      <p>Join schools using LOQT to build focus, reduce distractions, and improve student wellbeing.</p>
      <div class="cta-buttons">
        <button mat-flat-button (click)="navigateToSignup()" class="cta-large">
          Create School Account
        </button>
        <button mat-stroked-button (click)="navigateToLogin()" class="cta-large-secondary">
          Login to Your Account
        </button>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <footer class="landing-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <img src="/assets/icons/Loqt_Logotype-06.svg" alt="LOQT" class="footer-logo-image">
        <p>Less screen. More time.</p>
      </div>
      <div class="footer-links">
        <a routerLink="/whats-new">What's new</a>
        <a href="https://loqt.app/schools" target="_blank" rel="noopener">Learn More</a>
        <a href="https://loqt.app/contact" target="_blank" rel="noopener">Contact</a>
        <a href="https://loqt.app/privacy-policy" target="_blank" rel="noopener">Privacy</a>
      </div>
    </div>
  </footer>
</div>
